export default [
  {
    field: 'idString',
    label: 'autotopupregistrations.overview_id_column_heading',
    tooltip: 'autotopupregistrations.overview_id_tooltip',
    type: 'string',
    filterable: true,
    sortable: true,
    placeholder: ' ',
  },
  {
    field: 'translatedStatus',
    label: 'autotopupregistrations.overview_status_column_heading',
    tooltip: 'autotopupregistrations.overview_status_tooltip',
    type: 'string',
    filterable: true,
    sortable: true,
    placeholder: ' ',
  },
  {
    field: 'creationDatetime',
    label: 'autotopupregistrations.overview_creation_datetime_column_heading',
    tooltip: 'autotopupregistrations.overview_creation_datetime_tooltip',
    type: 'string',
    filterable: true,
    sortable: true,
    placeholder: ' ',
  },
  {
    field: 'deletionDatetime',
    label: 'autotopupregistrations.overview_deletion_datetime_column_heading',
    tooltip: 'autotopupregistrations.overview_deletion_datetime_tooltip',
    type: 'string',
    filterable: true,
    sortable: true,
    placeholder: ' ',
  },
  {
    field: 'formattedAmount',
    label: 'autotopupregistrations.overview_amount_column_heading',
    tooltip: 'autotopupregistrations.overview_amount_tooltip',
    type: 'number',
    filterable: true,
    sortable: true,
    placeholder: ' ',
  },
  {
    label: 'autotopupregistrations.overview_created_by_column_heading',
    tooltip: 'autotopupregistrations.overview_created_by_tooltip',
    filterable: false,
    sortable: false,
    placeholder: ' ',
  },
  {
    label: 'autotopupregistrations.overview_action_column_heading',
    tooltip: '',
    filterable: false,
    sortable: false,
    placeholder: ' ',
    action: true,
  },
];
